module.exports = __webpack_public_path__ + "img/topicMobility.b9970cff.svg";